export default "__VITE_ASSET__3ade7faa__"